import { CenterScreenModal } from '../atoms'
import { ConfirmationDialog } from '../organism'
import { useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks'

const defaultText = {
  en: {
    buttonText: 'Accept'
  },
  es : {
    buttonText: 'Aceptar'
  }
}

export const ConfirmDialogModal = () => {
  const { state, confirmDialogModalClose} = useOpeningElementsControllerContext();

  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? defaultText.es : defaultText.en
  
  return (
    <CenterScreenModal
      isOpen={state.isConfirmDialogModalOpen}
      onClose={confirmDialogModalClose}
    >
      <ConfirmationDialog
        title={state.modalText.title}
        description={state.modalText.description}
        confirmButton={{
          action: confirmDialogModalClose,
          text: state.modalText.buttonText ?? texts.buttonText
        }}
      />
    </CenterScreenModal>
  )
}